import { Box } from "components/ui/box";
import { Image } from "components/ui/image";
import React from "react";
import visaIcon from "../../assets/creditCardLogo/visa.png";
import mastercardIcon from "../../assets/creditCardLogo/mastercard.png";
import amexIcon from "../../assets/creditCardLogo/amex.png";

const CreditCardIconHandler = ({ type, isSmall }: any) => {
	let transformedType = type.toLowerCase();
	let creditCardIcon;

	switch (transformedType) {
		case "visa":
			creditCardIcon = visaIcon;
			break;
		case "mastercard":
			creditCardIcon = mastercardIcon;
			break;
		case "amex":
			creditCardIcon = amexIcon;
			break;
		default:
			creditCardIcon = null; // Or use a fallback icon if available
	}

	// Prevent rendering if the icon is null
	if (!creditCardIcon) {
		return null; // or render a placeholder
	}

	return (
		<Box>
			<Image source={creditCardIcon} style={{ width: isSmall ? 40 : 70, height: isSmall ? 30 : 50 }} />
		</Box>
	);
};

export default CreditCardIconHandler;
